{
  "general": {
    "retry": "再試行",
    "cancel": "キャンセル",
    "back_to_home": "ホームに戻る",
    "back": "戻る",
    "menu": "メニュー",
    "close": "閉じる",
    "edit": "編集",
    "delete": "削除",
    "complate": "完了",
    "approve": "承認",
    "select_all_users": "すべてのユーザーを選択",
    "deselect_all_users": "すべてのユーザーの選択を解除",
    "search": "検索",
    "share": "共有",
    "suggestion": "候補",
    "user": "ユーザー",
    "all_users": "すべてのMetamoryユーザー",
    "group": "グループ",
    "album": "アルバム",
    "address_book": "アドレス帳",
    "other": "その他",
    "later": "あとで",
    "storage": "ストレージ",
    "error": "エラー",
    "append_photo": "写真を追加",
    "delete_photo": "写真を削除",
    "remove_from": "{{name}}から削除",
    "removed_photo_from": "{{name}}から写真を削除しました",
    "error_occurred": "エラーが発生しました",
    "created": "{{name}}を作成しました",
    "loading": "読み込み中……",
    "change": "変更する",
    "email": "メールアドレス",
    "password": "パスワード",
    "set": "設定",
    "copied_clipboard": "クリップボードにコピーしました",
    "copied_clipboard_error": "クリップボードにコピーできませんでした",
    "updated": "更新しました",
    "please_select": "選択してください",
    "appended": "追加しました",
    "deleted": "削除しました",
    "login": "ログイン",
    "wip": "準備中！",
    "coming_soon": "近日公開予定！",
    "photos_num": "{{num}} 枚",
    "upgrade_plan": "プランをアップグレードする",
    "reload_page": "ページの更新",
    "long_session_message": "長時間ページを開き続けています。最新の状態に更新しますか？",
    "reload": "更新する",
    "open": "開く"
  },
  "header": {
    "profile": "プロフィール",
    "plan": "プラン",
    "setting": "設定",
    "help": "ヘルプとフィードバック",
    "about": "Metamoryについて",
    "logout": "ログアウト",
    "select_icon": "アイコンを選択"
  },
  "feature": {
    "home": "ホーム",
    "dm": "DM",
    "favorite": "お気に入り",
    "my_photo": "マイフォト",
    "my_album": "マイアルバム",
    "share_album": "共有アルバム",
    "notification": "通知",
    "invitation": "招待",
    "search_photo": "写真を検索",
    "reaction": "リアクション",
    "trash": "ゴミ箱"
  },
  "time": {
    "just_now": "たった今",
    "minute_ago": "1分前",
    "minutes_ago": "{{num}}分前",
    "hour_ago": "1時間前",
    "hours_ago": "{{num}}時間前",
    "yesterday": "昨日",
    "days_ago": "{{num}}日前",
    "month_ago": "1ヶ月前",
    "months_ago": "{{num}}ヶ月前",
    "year_ago": "1年前",
    "years_ago": "{{num}}年前"
  },
  "upload": {
    "upload_photo": "写真をアップロード",
    "auto_upload_photo": "写真を自動でアップロード",
    "uploading_photos": "写真をアップロード中",
    "drag_over": "写真をドロップするとアップロードできます",
    "upload_failed": "アップロードに失敗しました",
    "upload_success": "アップロードに成功しました",
    "storage_over_error": "ストレージ容量が足りません",
    "file_count_over_error": "ファイル数の上限に達しました",
    "file_format_error": "ファイルが不正です（例：解像度が大きすぎる等）",
    "file_break_error": "ファイルが壊れています",
    "file_size_lower_error": "ファイルサイズが小さすぎます(最低64KB)",
    "file_size_upper_error": "ファイルサイズが大きすぎます(最大100MB)",
    "iligal_data_error": "不正なデータです",
    "netrowk_error": "ネットワークエラー",
    "other_error": "エラー",
    "cancel_error": "キャンセルされました",
    "capacity_error": "容量が足りません",
    "edit_icon": "アイコンを編集",
    "iligal_data_error": "無効なデータです",
    "other_error": "エラー"
  },
  "photo_list": {
    "selected": "{{num}}枚を選択中",
    "selected_limit": "{{num}}枚以上選ぶことはできません",
    "footer": {
      "download": "写真を保存",
      "download_zip": "ZIPで保存",
      "zip_compressing": "ZIP圧縮中...",
      "append": "追加先を選択",
      "compare": "写真を比較",
      "delete": "写真を削除",
      "download_error": "保存に失敗しました",
      "download_success": "{{num}}枚の写真を保存しました",
      "delete_confirm": "{{num}}枚の写真を削除しますか？",
      "delete_success": "{{num}}枚の写真を削除しました"
    },
    "append_menu": {
      "new_album": "新しいアルバムを作成",
      "public_album": "全体公開アルバム",
      "public_album_lock": "全体公開アルバム（パスワード付き）"
    }
  },
  "sort": {
    "append_time_new": "追加の新しい順",
    "append_time_old": "追加の古い順",
    "myphoto_append_time_new": "新しい順",
    "myphoto_append_time_old": "古い順",
    "updated_at": "更新の新しい順",
    "reverse_updated_at": "更新の古い順",
    "name_asc": "名前の昇順",
    "name_desc": "名前の降順"
  },
  "photo": {
    "view_detail": "写真の詳細を表示",
    "delete_from_album": "アルバムから削除",
    "delete": "写真を削除",
    "delete_confirm": "写真をゴミ箱に移動しますか？",
    "delete_confirm_description": "アルバムやDMなど、ほかの場所からも削除されます。",
    "user_tag": "ユーザーをタグ付けする",
    "create_share_album": "共有アルバムを作成する",
    "search": "写真をユーザーで絞り込み",
    "only_my_photo": "マイフォトだけを表示",
    "new_favorite": "新しいお気に入りアルバムを作成して追加",
    "add_result": "「{{name}}」に追加しました",
    "add_favorite_result": "「{{name}}」にお気に入り登録しました",
    "change_favorite": "追加先の変更",
    "tagged_users": "タグ付けされたユーザー",
    "add_user_not_candidate": "候補にないユーザーを追加",
    "select_tag_user_title": "タグ付けするユーザーを選択",
    "not_registered": "Metamory未登録ユーザー",
    "share_success": "写真を共有しました",
    "share_error": "写真の共有に失敗しました",
    "share_not_supported": "お使いのブラウザでは写真の共有に対応していません",
    "share_prepared": "写真を準備しました。もう一度タップして共有してください",
    "add_users_from_edit": "「編集」からユーザーを追加",
    "no_tagged_users": "タグ付けされたユーザーはいません",
    "users_in_instance": "インスタンスにいたユーザー",
    "take_photo_with_others_or_enable_log": "他のユーザーがいるインスタンスで写真を撮るか、ログファイルの書き出しを有効にしてください",
    "install_sync_tool": "写真同期ツールをインストール",
    "auto_sync_users": "して、写っているユーザーを自動で同期",
    "all_users_tagged": "すべてのユーザーがタグ付けされています",
    "add_favorite_result": "「{{name}}」をお気に入りに追加しました"
  },
  "myphoto_tutorial": {
    "title": "Metamoryの写真同期ツールをインストールしよう！",
    "description": "写真同期ツールを使うとできること",
    "li1": "写真の自動アップロード",
    "li2": "写っているユーザーを自動で紐づけ",
    "li3": "撮影されたワールド情報の自動で取得",
    "li4": "プレイ時間に合わせた日付判定",
    "download": "Metamoryの写真同期ツールをダウンロード",
    "upload": "写真同期ツールをインストールせずに写真をアップロード",
    "tutorial_link_text": "写真同期ツールのインストール、起動、終了方法の手順は",
    "tutorial_link": "チュートリアル",
    "tutorial_link_suffix": "をご覧ください",
    "download_now": "今すぐダウンロード"
  },
  "reaction_selector": {
    "search_no_results_2": "そのリアクションは見つかりませんでした",
    "pick": "リアクションを選択...",
    "frequent": "よく使うリアクション"
  },
  "home": {
    "main": "メイン",
    "my_photos": "自分の写真",
    "vket": "Vket 2025 Summer",
    "new_photos_available": "{{count}}枚の新しい写真があります",
    "refresh": "更新",
    "storage_warning": "ストレージの空きが少なくなっています！"
  },
  "tutorial": {
    "title": "Metamoryへようこそ！",
    "description": "Metamoryを最大限活用するために、タスクを完了してみましょう",
    "profile_title": "プロフィールを完成させる",
    "profile_description": "あなたのプロフィールに写真や自己紹介、他のサービスのアカウント情報を追加して、他のユーザーから見つけてもらいやすくしてみましょう",
    "share_title": "共有アルバムを作成する",
    "share_description": "共有アルバムを作成して、他のユーザーに自分が撮った写真を見せたり、自分が写っている写真を共有してもらったりしてみましょう",
    "pc_client_title": "写真同期ツールをインストールする",
    "pc_client_description": "写真同期ツールを使うと、撮った写真を移動させるの忘れた…この人誰だっけ…どこで撮ったっけ…をなくせます！"
  },
  "favorite": {
    "create_list": "新しいお気に入りリストを作成",
    "special_favorite_name": "お気に入り",
    "no_title_favorite": "無題のお気に入り",
    "no_photos_title": "写真が登録されていません",
    "no_photos_description": "写真をお気に入りに登録して思い出を振り返りましょう",
    "edit_favorite": "お気に入りを編集",
    "delete_favorite_confirm": "このお気に入りリストを削除しますか？"
  },
  "notification": {
    "no_notification": "通知はありません",
    "no_notification_description": "あなた宛の通知が届くとここに表示されます",
    "no_invitation": "招待はありません",
    "no_invitation_description": "共有アルバムへの招待が届くとここに表示されます",
    "share_album_append": "{{num}}枚の写真が追加されました",
    "share_album_invitation": "「{{name}}」に招待されました",
    "share_album_owner_transferred": "「{{name}}」のオーナーになりました",
    "share_album_invitation_accept": "共有アルバムに参加する",
    "invitation_accepted": "招待を受諾しました",
    "joined_album": "{{albumName}}に参加しました"
  },
  "album": {
    "create_album": "アルバムを新規作成",
    "no_title_album": "無題のアルバム",
    "number_of_photos": "{{num}}枚の写真",
    "add_photo": "写真を追加",
    "invitation_album": "アルバムに招待",
    "get_link": "リンクを取得",
    "no_photos": "写真がありません",
    "album_no_photo": "アルバムに写真がありません",
    "album_no_photo_description": "アルバムに写真を追加して思い出を共有しましょう",
    "delete_album_success": "アルバムを削除しました",
    "delete_album_confirm": "このアルバムを削除しますか？",
    "confirm_change_share": "このアルバムを共有しますか？\n（マイアルバムには戻せません）"
  },
  "share": {
    "not_found_title": "アルバムが存在しません",
    "not_found_description": "アルバムが削除されたか、URLが間違っている可能性があります",
    "back_to_share_list": "共有アルバム一覧に戻る",
    "empty_shares_title": "共有アルバムを作成して、みんなと写真を共有してみましょう",
    "empty_shares_description": "共有アルバムを作成して写真を追加すると、自分が撮った写真を他のユーザーに共有したり、他のユーザーから写真を共有してもらうことができます",
    "create_share_album": "新しい共有アルバムを作成する",
    "share_range": "共有範囲",
    "share_range_description": "誰に向けて共有するかを選択できます",
    "invite_only": "オーナーのみ招待可能",
    "invite_only_description": "あなたがアルバムに招待したユーザーのみが参加できます",
    "invite_plus": "誰でも招待可能",
    "invite_plus_description": "あなたがアルバムに招待したユーザーが、アルバムに他のユーザーを招待できます",
    "public": "全体公開",
    "public_description": "リンクを知っている人なら誰でも観覧できます",
    "public_lock": "全体公開（パスワードつき）",
    "public_lock_description": "リンクを知っている人が、パスワードを入力すると観覧できます",
    "invite_only_public_view": "全体公開（オーナーのみ編集者の招待可能）",
    "invite_only_public_view_description": "メンバー管理は招待制ですが、リンクを知っている人なら誰でも観覧・リアクションできます",
    "invite_plus_public_view": "全体公開（編集者は編集者の招待可能）",
    "invite_plus_public_view_description": "招待されたユーザーが他のユーザーを招待でき、リンクを知っている人なら誰でも観覧・リアクションできます",
    "member_list": "参加ユーザーリスト",
    "leave_share_album": "共有アルバムを抜ける",
    "leave_share_album_confirm": "この共有アルバムを抜けますか？",
    "leave_share_album_success": "共有アルバムを抜けました",
    "edit_album": "アルバムの設定",
    "delete_album": "アルバムを削除",
    "approval_awaiting_list": "承認待ちのユーザーリスト",
    "album_login_required": "このアルバムを観覧・編集するには、\nMetamoryへのログインが必要です",
    "approval_awaiting_users": "承認待ちのユーザー",
    "approval_awaiting_empty_title": "承認待ちのユーザーはいません",
    "approval_awaiting_empty_description": "現在、承認待ちのユーザーはいません。\n新しい参加申請があるとここに表示されます。",
    "invitation_users": "招待中のユーザー",
    "invitation_users_list": "招待中のユーザーリスト",
    "invitation_empty_title": "招待中のユーザーはいません",
    "invitation_empty_description": "現在、招待中のユーザーはいません。\nユーザーを招待するとここに表示されます。",
    "invitation_canceled": "招待を取り消しました",
    "cancel_invitation_confirm": "このユーザーの招待を削除しますか？\n（アルバムに参加してもらうには再度招待が必要です）",
    "cancel_invitation_button": "招待を削除",
    "auto_approval": "参加申請の自動承認",
    "auto_approval_description": "ONにすると、アルバムへの参加（観覧・編集等が可能）の申請があった際に自動で承認されます\nOFFの場合はアルバムの「承認待ちのユーザーリスト」に登録されます",
    "share_type_change_warning_title": "共有設定の変更確認",
    "warning_public_to_private": "招待制に変更すると、招待されていないユーザーはアクセスできなくなります",
    "warning_private_to_public": "全体公開に変更すると、招待されていないユーザーもアクセス可能になります",
    "warning_invite_permission_change": "メンバーの招待権限が変更されます",
    "confirm_change": "変更する",
    "change_owner": "アルバムオーナーを変更",
    "change_owner_confirm": "アルバムオーナーを変更すると、\nアルバムの設定ができなくなります",
    "change_owner_button": "オーナーを変更",
    "change_owner_success": "アルバムオーナーを変更しました",
    "select_owner_empty_title": "変更可能なメンバーがいません",
    "select_owner_empty_description": "オーナーを変更するには、アルバムにメンバーを招待してください。\nメンバーがいない場合、オーナーの変更はできません。",
    "add_users_title": "ユーザーを招待",
    "add_users_empty_title": "ユーザーを検索してください",
    "add_users_empty_description": "上の検索ボックスでユーザー名やIDを入力して、\n招待したいユーザーを検索できます",
    "join_request_message": "このアルバムを閲覧・編集するには参加申請が必要です",
    "request_to_join": "参加を申請",
    "join_request_success": "参加申請を送信しました",
    "join_auto_approved": "アルバムに参加しました",
    "users_approved": "ユーザーを承認しました",
    "invite_users": "ユーザーを招待",
    "invited_users": "招待中のユーザー",
    "cancel_invitation": "招待を取り消す",
    "invited_by": "{{name}}さんから招待されました",
    "accept_invitation": "承認",
    "decline_invitation": "拒否",
    "user_invited": "ユーザーを招待しました",
    "viewing_password": "閲覧パスワード",
    "set_viewing_password": "閲覧パスワードを設定してください",
    "set_viewing_password_success": "閲覧パスワードを設定しました",
    "enter_password": "このアルバムを閲覧・編集するには、パスワードが必要です",
    "view": "閲覧",
    "password_error": "パスワードが違います",
    "member": "参加しているユーザー",
    "kick_from_album": "アルバムからキック",
    "kick_success": "アルバムからキックしました",
    "delete_share_confirm": "このアルバムを削除しますか？\n（削除すると、他のユーザーもアルバムを閲覧できなくなります）",
    "leave_share_confirm": "アルバムから脱退しますか？\n（脱退すると、アルバムが閲覧できなくなります）",
    "leave": "脱退",
    "link_copied": "共有リンクをコピーしました",
    "login_dialog": "このアルバムを閲覧・編集するには、\nMetamoryへのログインが必要です",
    "encourage_register_message": "Metamoryに登録して\nアルバムをフレンドと共有しよう",
    "start_metamory": "Metamoryをはじめる",
    "is_sensitive_label": "センシティブなアルバム",
    "is_sensitive_description": "ONにすると、18歳未満のユーザーはアルバムを閲覧できなくなります"
  },
  "modal": {
    "logout_message": "ログアウトしますか？",
    "confirm_leave_page": "変更が保存されていませんが、ページを離れますか？",
    "leave_page": "ページを離れる",
    "confirm_discard_edit": "編集内容は保存されていません。破棄して閉じますか？",
    "discard_edit": "破棄して閉じる",
    "login_confirm": "ログインページに移動しようとしています\nよろしければ「移動」を押してください"
  },
  "popup_menu": {
    "choice_favorite": "お気に入りの選択",
    "choice_reaction": "リアクションの選択",
    "reaction_detail": "リアクションの詳細",
    "photo_detail": "写真の詳細",
    "create_myalbum": "マイアルバムを新規作成",
    "choice_photo_append_type": "追加先を選択",
    "choice_photo_append_myalbum": "マイアルバムを選択",
    "choice_photo_append_share": "共有アルバムを選択",
    "choice_photo_append_public_album": "全体公開アルバムを選択",
    "choice_photo_append_public_lock_album": "全体公開アルバム（パスワード付き）を選択",
    "choice_photo_append_favorite": "お気に入りを選択",
    "choice_photo_append_dm": "DMを選択"
  },
  "address_book": {
    "add_user": "新しいユーザーを追加",
    "empty_user_title": "登録したユーザーがいません",
    "empty_user_description": "ユーザーをアドレス帳に追加して写真を共有しましょう",
    "create_group": "新しいグループを作成",
    "empty_group_title": "作成したグループはありません",
    "empty_group_description": "ユーザーをグループに登録してスムーズに共有しましょう",
    "book_user": "アドレス帳に追加する"
  },
  "user": {
    "add_book": "登録する",
    "add_book_success": "アドレス帳に追加しました",
    "in_book": "登録中",
    "add_group": "グループに追加",
    "outbook_dialog_message": "このユーザーの登録を解除しますか？\n（あとで登録し直すこともできます）",
    "out_book": "登録解除",
    "mute_user": "このユーザーをミュート",
    "unmute_user": "ミュート解除",
    "mute_dialog_message": "このユーザーをミュートしますか？\n（ミュートしたユーザーの写真は見ることができなくなります）",
    "mute": "ミュート",
    "mute_warning": "このユーザーをミュートしているため、このユーザーが追加した写真やリアクションは見ることができません",
    "muted_user": "ユーザーをミュートしました",
    "report_user": "ユーザーを報告",
    "report_this_user": "このユーザーを報告",
    "report_dialog_message": "ガイドラインに違反している内容を選択してください",
    "report_reason_icon": "不適切なアイコン画像",
    "report_reason_icon_detail": "ガイドラインに違反する写真をアイコンに使用している　など",
    "report_reason_name": "不適切なユーザー名・ID",
    "report_reason_name_detail": "ユーザー名やIDに、ガイドラインに違反する言葉が含まれている　など",
    "report_reason_description": "不適切な自己紹介文",
    "report_reason_description_detail": "自己紹介文に、ガイドラインに違反する言葉が含まれている　など",
    "report_reason_other": "その他",
    "report_reason_other_detail": "上記に当てはまらない、ガイドラインに違反するコンテンツ",
    "reported_user": "ユーザーを報告しました",
    "report_error_user_not_found": "ユーザーが見つかりませんでした",
    "unmuted_user": "ユーザーのミュートを解除しました",
    "add_group_success": "グループ「{{name}}」に追加しました",
    "search_no_result": "検索条件に合う結果がありません",
    "search_no_result_description": "正確なユーザー名を入力したり、ユーザーIDで検索するとフレンドを見つけやすくなります",
    "search_friend_not_found": "フレンドが見つからないときは？",
    "search_friend_not_found_description": "正確なユーザー名で入力したり、ユーザーIDで検索するとフレンドを見つけやすくなります",
    "frozen_account": "このアカウントは<l>Metamoryの利用規約</l>に違反したため、凍結されています。",
    "frozen_user_name": "凍結済みユーザー"
  },
  "profile": {
    "edit_profile": "プロフィールを編集",
    "edit_profile_success": "プロフィールを更新しました",
    "user_id": "ユーザーID",
    "user_id_char_error": "英数字または\"_\"で入力してください",
    "user_name": "ユーザー名",
    "user_description": "自己紹介メッセージ",
    "collaboration_other_service": "他のサービスとの連携",
    "vrchat_input_hint": "VRChatのユーザーページのURLを貼り付けると自動で変換されます（例：https://vrchat.com/home/user/usr_XXXXX）",
    "twitter_input_hint": "X(Twitter)のユーザーページのURLを貼り付けると自動で変換されます（例：https://x.com/XXXXX）",
    "exist_metamory_id": "このIDはすでに使用されています"
  },
  "group": {
    "no_title_group": "無題のグループ",
    "edit_group": "グループを編集",
    "delete_group": "グループを削除",
    "delete_group_confirm": "このグループを削除しますか？",
    "users_length": "{{num}}人を登録中",
    "users_0": "登録ユーザーはいません",
    "add_user": "ユーザーをグループに追加",
    "add_user_min": "グループに追加する",
    "no_user": "グループにユーザーが追加されていません",
    "no_user_description": "ユーザーをグループに追加してスムーズに共有しましょう",
    "san": "{{name}}さん",
    "comma": "、"
  },
  "dm": {
    "create_dm": "新しいDMを作成",
    "no_dms": "DMがありません",
    "no_dms_description": "フレンドを検索してDMを送ってみましょう",
    "no_photos_title": "DMに写真がありません",
    "no_photos_description": "DMに写真を送信して思い出を共有しましょう",
    "dm_title": "{{name}}さんとのDM",
    "append_photos": "{{name}}さんとのDMに写真を追加しました",
    "search_user": "ユーザーを検索",
    "search_user_description": "ユーザーを検索してDMを作成しましょう"
  },
  "auth": {
    "current_password": "現在のパスワード",
    "new_password": "新しいパスワード",
    "confirm_new_password": "新しいパスワード（確認）",
    "update_password": "新しいパスワードを設定",
    "passwords_must_match": "パスワードが一致しません",
    "attempt_limit_exceeded": "試行回数が上限に達しました。しばらく待ってから再試行してください",
    "password_too_long": "パスワードは256文字以下で設定してください",
    "password_edge_whitespace": "パスワードの先頭と末尾に空白は使えません",
    "password_policy": "{{num}}文字以上",
    "show_password": "{{field}}を表示",
    "hide_password": "{{field}}を隠す",
    "invalid_credentials": "メールアドレスまたはパスワードが違います",
    "incorrect_current_password": "現在のパスワードが違います",
    "session_expired": "ログインの有効期限が切れました。ログインし直してください",
    "invalid_code": "確認コードが違うか、有効期限が切れています",
    "network_error": "通信に失敗しました。接続を確認して再試行してください",
    "unexpected_error": "処理に失敗しました。もう一度お試しください",
    "username_exists": "このメールアドレスは既に登録されています",
    "invalid_password": "パスワードが条件を満たしていません",
    "sign_in": "ログイン",
    "sign_up": "新規登録",
    "forgot_password": "パスワードをお忘れですか？",
    "back_to_sign_in": "ログインに戻る",
    "create_account": "アカウントを作成",
    "confirm_sign_up_title": "メールアドレスの確認",
    "confirm_sign_up_description": "{{email}} に送信した確認コードを入力してください",
    "confirmation_code": "確認コード",
    "confirm": "確認",
    "resend_code": "コードを再送",
    "code_resent": "確認コードを再送しました",
    "reset_password_title": "パスワードの再設定",
    "reset_password_description": "登録したメールアドレスに確認コードを送信します",
    "send_code": "コードを送信",
    "reset_password_code_description": "{{email}} に送信した確認コードと、新しいパスワードを入力してください",
    "reset_password": "パスワードを再設定",
    "password_reset_done": "パスワードを再設定しました。新しいパスワードでログインしてください",
    "sign_up_confirmed": "登録が完了しました。ログインしてください",
    "already_confirmed": "このメールアドレスは確認済みです。ログインしてください",
    "user_not_found": "このメールアドレスのアカウントが見つかりません",
    "unverified_reset": "このアカウントは確認が済んでいないため、パスワードを再設定できません。ログインすると確認コードを送り直せます",
    "contact_admin": "このアカウントはパスワードの設定が必要です。ヘルプとフィードバックからお問い合わせください",
    "continue": "次へ",
    "checking_passkey": "パスキーを確認しています…",
    "retry_with_passkey": "パスキーでもう一度試す",
    "use_different_email": "別のメールアドレスを使う",
    "password_step_hint": "パスワードを入力してログインしてください",
    "passkey_canceled_hint": "パスキーでのログインをキャンセルしました。パスワードを入力するか、もう一度パスキーをお試しください",
    "passkey_failed_hint": "パスキーでログインできませんでした。パスワードを入力するか、もう一度パスキーをお試しください"
  },
  "setting": {
    "profile_title": "アカウント設定",
    "profile_description": "アカウントのメールアドレスやパスワードなどの設定ができます",
    "notification_title": "通知設定",
    "notification_description": "Metamoryが送信する通知を管理します",
    "display_and_accessibility_title": "表示とアクセシビリティ",
    "display_and_accessibility_description": "画面の表示や言語を設定できます",
    "ui_theme_title": "UIテーマ",
    "ui_theme_description": "UIテーマを設定できます",
    "color_mode_system": "システム設定に従う",
    "color_mode_light": "ライトモード",
    "color_mode_dark": "ダークモード",
    "client_application_title": "写真同期ツール",
    "client_application_description": "写真同期ツールのダウンロードや各種設定ができます",
    "language_title": "言語",
    "language_description": "表示言語を選択できます",
    "language_japanese": "日本語",
    "language_english": "English",
    "language_korean": "한국어",
    "account_setting": "アカウント設定",
    "set_new_password": "新しいパスワードを設定",
    "delete_account": "アカウントを削除",
    "delete_account_confirm": "あなたはこのアカウントを完全に削除しようとしています。\n\nアカウントを削除すると、<ul><li>すべての写真が削除されます。</li><li>すべての共有したアルバムが削除されます。</li><li>自分が行ったリアクションや、自分の写真につけられたリアクションがすべて削除されます。</li><li>容量追加など、アカウントに関連するすべてのデータが削除されます。</li><li>削除したアカウントを元に戻すことはできません。</li></ul>本当にアカウントを削除しますか？",
    "change_email": "メールアドレスの変更",
    "change_email_description": "アカウントのメールアドレスを変更できます",
    "current_email": "現在のメールアドレス",
    "new_email": "新しいメールアドレス",
    "confirm_code_title": "確認コードを入力",
    "verification_code": "確認コード",
    "confirmation_email_sent": "確認メールを送信しました",
    "change_password": "パスワードの変更",
    "change_password_description": "アカウントのパスワードを変更できます",
    "passkey_description": "指紋・顔認証・画面ロックでログインできるようにします",
    "password_updated": "パスワードを更新しました",
    "metamory_id": "Metamory ID",
    "your_metamory_id": "あなたのMetamory ID",
    "delete_account_input_confirm": "アカウントを削除する場合は、確認のためMetamory IDを入力してください。",
    "notification": {
      "share_reaction": "写真へのリアクション",
      "share_add_photo": "共有アルバムへの写真追加",
      "share_name_change": "共有アルバムの名前の変更",
      "share_type_change": "共有範囲の変更",
      "dm_receive": "DMを受け取ったとき",
      "dm_reaction": "写真へのリアクション"
    },
    "client_application": {
      "title": "写真同期ツール",
      "tutorial_instruction": "写真同期ツールのインストール、起動、終了方法の手順は下記のチュートリアルをご覧ください",
      "tutorial_button": "写真同期ツールのチュートリアル",
      "installed_devices": "写真同期ツールをインストールしたデバイス一覧",
      "installed_devices_description": "現在同期に使用しているデバイスの一覧",
      "device_disconnect": "デバイスの切断",
      "device_disconnect_description": "切断したデバイスを再度接続する場合は、接続したいデバイスの写真同期ツールを開いて設定しなおしてください",
      "disconnect": "切断",
      "disconnect_confirm": "このデバイスを切断しますか？\n（切断すると自動アップロードも停止します）",
      "client_application_download": "写真同期ツールをダウンロード",
      "client_application_download_description_mobile": "写真同期ツールは、MetamoryのPCブラウザ版からダウンロードすることができます",
      "client_application_download_description_pc": "写真同期ツールをダウンロードすると、VRで撮影した写真をMetamoryに自動でアップロードすることができます",
      "download_pwa": "Webアプリのダウンロード",
      "download_pwa_description": "（Google Chromeをご利用の場合）\n「その他」メニューから「ホーム画面に追加」を押すと、お使いのスマートフォンにMetamoryを追加できます"
    },
    "privacy_and_safety_title": "プライバシーと安全",
    "privacy_and_safety_description": "ミュートしたユーザーなどを管理します",
    "muted_users_title": "ミュートしたユーザー",
    "muted_users_description": "ミュートしているユーザーの一覧を見ることができます",
    "muted_users_header": "ミュートしたユーザー",
    "muted_users_empty_title": "ミュートしたユーザーはいません",
    "muted_users_empty_description": "ミュートしたユーザーはここに表示されます",
    "unmute_dialog_message": "このユーザーのミュートを解除しますか？",
    "unmute_button": "ミュートを解除",
    "unmuted_user_success": "ミュートを解除しました"
  },
  "welcome": {
    "welcome": "Metamoryへようこそ！",
    "description": "まずはプロフィールを設定して、\nフレンドから見つけてもらいやすくしましょう",
    "set_profile": "プロフィールを設定",
    "sign_out_description": "間違ったアカウントで登録してしまった方はこちら",
    "sign_out": "ログアウト"
  },
  "help": {
    "how_to_use_title": "Metamoryの使い方",
    "how_to_use_description": "Metamoryの各機能の使い方はこちらからご確認ください。",
    "populer_question_title": "よくある質問",
    "populer_question_description": "よくある質問にQ&A方式で回答しています",
    "feedback_title": "フィードバック",
    "feedback_description": "不具合報告や機能の改善はこちらからお問い合わせください (Metamory公式Discordサーバーに遷移します)",
    "discord_title": "公式Discordコミュニティ",
    "discord_description": "Metamoryユーザーや運営との交流を楽しみたい方はこちら！",
    "go_out_site_confirm": "外部サイトに移動しようとしています\nよろしければ「移動」を押してください",
    "go": "移動",
    "go_discord_confirm": "Metamory公式サーバー（Discord）に移動します",
    "go_discord": "移動",
    "privacy_policy_and_terms_description": "Metamoryの利用規約とプライバシーポリシーについてはこちらからご確認ください"
  },
  "trash": {
    "moved_to_trash": "写真をゴミ箱に移動しました",
    "open_trash": "ゴミ箱を開く",
    "empty_trash": "ゴミ箱は空です",
    "empty_trash_description": "写真を削除すると、30日間はゴミ箱に保存されます",
    "restore": "マイフォトに戻す",
    "delete_from_trash": "完全に削除",
    "delete_all_from_trash": "ゴミ箱の写真を完全に削除",
    "delete_from_trash_confirm": "{{num}}枚の写真を削除しますか？\n（写真はMetamoryから完全に削除されます）",
    "deleted_from_trash": "写真を完全に削除しました",
    "deleting_in_background": "バックグラウンドで削除中です",
    "processing_in_background": "バックグラウンドで処理中です",
    "restored_from_trash": "写真をマイフォトに戻しました",
    "trashed_on": "{{date}}に削除"
  },
  "search": {
    "user": "{{name}}さんの写真",
    "owner": "撮影したユーザー",
    "in_users": "写っているユーザー"
  },
  "accept_rules": {
    "mobile_title": "利用規約の改定",
    "dialog_title": "新しい利用規約とプライバシーポリシー",
    "dialog_description": "Metamoryの利用規約とプライバシーポリシーが改定されました。詳細は<l>利用規約とプライバシーポリシー</l>をご確認ください",
    "accept": "同意して進む"
  },
  "error": {
    "occurred": "エラーが発生しました",
    "occurred_message": "ご迷惑をおかけして申し訳ありません。\nお手数ですが、ブラウザを更新して操作をやり直してください\nスマートフォン・Chrome等でインストールした方はMetamoryを再起動してください\nこの画面が何度も表示される場合はフィードバックを送信してください",
    "occurred_with_trace": "エラーが発生しました (トレースID: {{traceId}})",
    "text_length_over": "文字数が{{limit}}文字を超えています（現在{{num}}文字）",
    "text_bytes_over": "文字数が{{limit}}バイトを超えています（現在{{num}}バイト）",
    "text_length_fewer": "文字数が{{limit}}文字未満です（現在{{num}}文字）",
    "404_title": "ページが見つかりません",
    "404_description": "がんばって探しましたが、お探しのページが見つかりませんでした",
    "general": "エラーが発生しました",
    "update": "更新に失敗しました",
    "update_with_trace": "更新に失敗しました (トレースID: {{traceId}})",
    "analysis_info": "エラー解析用情報",
    "photo_not_found": "写真がありません",
    "photo_not_found_with_trace": "写真がありません (トレースID: {{traceId}})",
    "fetch": "データの取得に失敗しました",
    "fetch_with_trace": "データの取得に失敗しました (トレースID: {{traceId}})",
    "fetch_limit_stop": "同じサーバ要求が一度に多数発生したため、停止しました",
    "fetch_data_with_trace": "取得したデータに誤りがあります (トレースID: {{traceId}})",
    "fetch_me": "ユーザー情報の取得に失敗しました",
    "fetch_me_with_trace": "ユーザー情報の取得に失敗しました (トレースID: {{traceId}})",
    "fetch_notifications": "通知の取得に失敗しました",
    "fetch_notifications_with_trace": "通知の取得に失敗しました (トレースID: {{traceId}})",
    "create": "作成に失敗しました",
    "create_with_trace": "作成に失敗しました (トレースID: {{traceId}})",
    "delete": "削除に失敗しました",
    "delete_with_trace": "削除に失敗しました (トレースID: {{traceId}})",
    "upload": "アップロードに失敗しました"
  },
  "photo_editor": {
    "title": "写真を編集",
    "menu_label": "写真を編集",
    "upload_success": "編集した写真を保存しました",
    "crop_free": "自由",
    "crop_full": "全体",
    "aspect_ratio_label": "比率",
    "rotate_label": "回転",
    "rotate_left": "左に回転",
    "rotate_right": "右に回転",
    "share_to_x": "Xに投稿",
    "share_to_x_copied": "画像をコピーしました。\n以下のボタンでXの投稿画面を開き、貼り付けて投稿できます",
    "share_to_x_open": "Xを開く",
    "share_to_x_error": "クリップボードへのコピーに失敗しました"
  },
  "photo_sticker": {
    "title": "ステッカーを作成",
    "menu_label": "ステッカーを作成",
    "coach_mark": "ステッカー機能を試してみよう！",
    "select_photo": {
      "leave_confirm": "ステッカーにする写真選びをやめますか？",
      "title": "ステッカーにする写真を選択",
      "guide_title": "ステッカーにしたい写真をタップ"
    },
    "settings_tabs": "ステッカー設定",
    "border_tab": "縁取り",
    "text_tab": "文字",
    "watermark_tab": "ウォーターマーク",
    "preview": "ステッカープレビュー",
    "border_size_label": "縁取り",
    "border_color_label": "縁取り色",
    "text_input_label": "文字",
    "text_font_label": "フォント",
    "text_font_name_default": "デフォルト",
    "text_font_group_standard": "標準",
    "text_font_group_japanese": "日本語",
    "text_font_group_korean": "韓国語",
    "text_font_group_latin": "欧文",
    "text_font_loading": "フォントを読み込み中",
    "text_font_load_error": "フォントを読み込めませんでした。通信環境を確認してください",
    "prepare_error": "画像を読み込めませんでした。もう一度お試しください",
    "text_size_label": "文字サイズ",
    "text_italic_label": "イタリック",
    "text_placement_label": "重なり",
    "text_behind": "背面",
    "text_front": "前面",
    "text_color_label": "文字色",
    "text_background_label": "背景",
    "text_background_none": "なし",
    "text_background_outline": "フチ",
    "text_background_bubble": "吹き出し",
    "text_outline_color_label": "文字フチ",
    "text_outline_color_short": "フチ色",
    "bubble_color_label": "吹き出し色",
    "bubble_border_color_label": "吹き出し枠色",
    "bubble_color_short": "塗り色",
    "bubble_border_color_short": "枠色",
    "bubble_border_none": "吹き出し枠なし",
    "bubble_tail_label": "しっぽの向き",
    "bubble_tail_up_left": "上左",
    "bubble_tail_up": "上",
    "bubble_tail_up_right": "上右",
    "bubble_tail_right_up": "右上",
    "bubble_tail_right": "右",
    "bubble_tail_right_down": "右下",
    "bubble_tail_down_right": "下右",
    "bubble_tail_down": "下",
    "bubble_tail_down_left": "下左",
    "bubble_tail_left_down": "左下",
    "bubble_tail_left": "左",
    "bubble_tail_left_up": "左上",
    "watermark_label": "ウォーターマーク",
    "upload_to_vrchat": "VRChatにアップロード",
    "vrchat_upload_description": "VRChatのステッカー用に、{{max}}pxに合わせたPNGをダウンロードできます。\nダウンロード後、VRChatのステッカーアップロード画面で画像を選択してください。",
    "download_for_vrchat": "VRChat用にダウンロード",
    "open_vrchat_upload": "アップロード画面を開く",
    "download": "ダウンロード",
    "remaining": "残り{{count}}回",
    "remaining_exhausted": "また来週",
    "quota_exceeded": "今週のステッカー作成上限に達しました。来週またご利用いただけます",
    "confirm_close_without_export": "この画面を閉じると、編集中のステッカーは保存されず、ステッカー作成回数は戻りません。ステッカーの作成を中止しますか？",
    "close_without_export": "中止"
  },
  "campaign": {
    "vket2025summer_applied": "キャンペーンが適用されました\n写真の最大保存枚数が2000枚になりました",
    "applied": "キャンペーンが適用されました！"
  },
  "pr": {
    "vket": {
      "post_timeline": "Vketタイムラインに投稿",
      "cancel_post_timeline": "投稿をキャンセル",
      "already_post_timeline": "Vketタイムラインに投稿済み",
      "success_post_timeline": "Vketのタイムラインに投稿されました",
      "error_post_timeline": "投稿できませんでした、再度お試しください",
      "already_posted": "この写真は既にVketタイムラインに投稿されています",
      "no_world_info": "ワールド情報がありません。写真同期ツールをインストールしてください",
      "not_world": "Vket 2025 Summerのワールドでは無いので投稿できません"
    },
    "honda2026": {
      "post_timeline": "Honda Motanionタイムラインに投稿",
      "cancel_post_timeline": "投稿をキャンセル",
      "already_post_timeline": "Honda Motanionタイムラインに投稿済み",
      "success_post_timeline": "Honda Motanionのタイムラインに投稿されました",
      "error_post_timeline": "投稿できませんでした、再度お試しください",
      "already_posted": "この写真は既にHonda Motanionタイムラインに投稿されています",
      "no_world_info": "ワールド情報がありません。写真同期ツールをインストールしてください",
      "not_world": "Honda Motanionのワールドでは無いので投稿できません"
    },
    "vket2025winter": {
      "start_metamory": "Metamoryを始める",
      "benefit_timing_title": "特典付与の時期",
      "benefit_timing_date": "2026年1月末ごろ",
      "condition1_title": "【条件①】Metamory 1,500枚特典の獲得条件",
      "condition1_step1": "Vket 2025 Winter でグランドマスターを達成する",
      "condition1_step1_detail": "グランドマスター達成方法の詳細は",
      "condition1_step1_link": "こちら",
      "condition1_step2": "まだ Metamory 未登録の場合",
      "condition1_step2_link": "こちら",
      "condition1_step2_1": "より会員登録を進めてください",
      "condition1_step2_2": "Metamory 会員登録後に PCアプリのインストール & ログインを行う",
      "condition1_step2_note": "※インストールやログインができない場合、下記のサポートをご確認ください",
      "condition1_step2_help": "Metamory ヘルプページ",
      "condition1_step2_discord": "Metamory ユーザーコミュニティ Discord",
      "condition1_step3": "既に Metamory 登録済の場合",
      "condition1_step3_detail": "必要な対応はありません！",
      "condition1_step4": "手続き完了！",
      "condition1_step4_detail": "2026年1月末ごろに自動的に上限数が反映されます",
      "condition2_title": "【条件②】Metamory 2,000枚特典の獲得条件",
      "condition2_step1": "【条件①】達成後に「共有アルバム」を作成する",
      "condition2_step1_detail": "ホーム画面「共有アルバム」の「アルバムを新規作成」からアルバムを作成して公開する（※アルバムの種類は問いません）",
      "condition2_step2": "手続き完了！",
      "condition2_step2_detail": "2026年1月末ごろに自動的に上限数が反映されます",
      "faq_title": "FAQ",
      "faq_q1": "Q. 既に Metamory に登録しておりPCアプリのインストール & ログインも完了した状態で、グランドマスターを達成した場合でも自動的に 1,500 枚になるのでしょうか？",
      "faq_a1": "A. はい、自動的に1,500枚になります！",
      "faq_a1_detail": "2026年1月末ごろに上限数が反映されますのでお待ちください",
      "faq_q2": "Q. グランドマスター達成後に Metamory の会員登録をしませんでした。特典の有効期限はいつまでですか？",
      "faq_a2": "A. 2026年1月18日までとなります！",
      "faq_a2_detail": "特典有効期限を経過した場合、付与はできないためお気をつけください",
      "faq_q3": "Q. 過去の Metamory キャンペーンでストレージ上限が 1,000枚 以上になっている場合、更に追加されるのでしょうか？（現在2,000枚の場合、3,500枚になるのでしょうか？）",
      "faq_a3": "A. 更に追加はされません…！",
      "faq_a3_detail": "既に上限が 2,000 枚の方が【条件1】を達成することで 1,500 枚にダウングレードされることはありませんのでご安心ください",
      "top_image_alt": "Vket 2025 Winterのトップ画像",
      "middle_image_alt": "Vket 2025 Winterのメイン画像"
    }
  },
  "about": {
    "sticker_tutorial": {
      "images": {
        "result": "文字と縁取りを加えたステッカーの完成例",
        "create": "写真ビューワーのメニューにある「ステッカーを作成」",
        "edit": "ステッカー編集画面の縁取りと文字のタブ、縁取りの調整"
      },
      "title": "写真からステッカーを作ろう",
      "choose_photo": "マイフォトからステッカーを作る",
      "back": "戻る",
      "result": {
        "title": "完成イメージ",
        "body": "写真の被写体を切り抜き、文字や縁取りを加えて、自分だけのステッカーにできます。"
      },
      "open": {
        "title": "1. 写真を開く",
        "body": "<photos>マイフォト</photos>から写真を開きます。",
        "note": "マイフォトには自分がアップロードした写真が表示されます。他の人の写真からはステッカーを作成できません。"
      },
      "create": {
        "title": "2. 作成を始める",
        "body": "写真ビューワー右上のメニュー（⋮）から「ステッカーを作成」を選びます。",
        "note": "作成回数には週ごとの上限があります。上限に達した場合は翌週また利用できます。"
      },
      "edit": {
        "title": "3. アレンジする",
        "body": "「縁取り」でフチを調整し、「文字」で好きな言葉を追加します。文字のフォント・サイズ・色や吹き出しの背景を選べます。"
      },
      "save": {
        "title": "4. 保存して使う",
        "body": "「ダウンロード」で画像を保存できます。VRChat内で使う場合は、共有アイコンから「VRChatにアップロード」を開き、「VRChat用にダウンロード」を選びます。ダウンロードしたステッカーをVRChatの専用ページからアップロードしてください。"
      }
    },
    "info": "お知らせ",
    "view_old_info": "過去のお知らせを見る",
    "hide_old_info": "過去のお知らせを省略する",
    "register_account": "新規登録してはじめる",
    "wish_openbeta_account": "Metamoryにログインする",
    "goto_metamory": "Metamoryへ",
    "twitter_link": "Metamory 公式X",
    "privacy_policy_and_terms": "利用規約とプライバシーポリシー",
    "privacy_policy_description": "詳しくは<l>利用規約とプライバシーポリシーページ</l>をご確認ください。",
    "child_safe_policy": "チャイルドセーフティポリシー",
    "help_description": "操作方法やアカウント管理などでお困りの場合は<l>ヘルプページ</l>をご確認ください。",
    "tradelaw": "特定商取引法に関する表示",
    "faq": {
      "faq": "よくある質問",
      "how_to_use": "Metamoryの使い方",
      "contact": "お問い合わせ"
    },
    "client_tutorial": {
      "title": "写真同期ツールのチュートリアル",
      "table_of_contents": "目次",
      "contents": {
        "download": "1.ダウンロード",
        "install": "2.インストール",
        "confirm": "3.起動確認",
        "faq": "よくある質問"
      },
      "images": {
        "settings_screen": "設定画面",
        "download_button": "ダウンロードボタン",
        "download_file": "ダウンロードファイル",
        "windows_protection": "Windows保護画面",
        "signin_screen": "サインイン画面",
        "browser_auth_screen": "ブラウザ認証画面",
        "syncing_device": "同期中のデバイス",
        "notification_area": "通知領域",
        "dashboard": "ダッシュボード"
      },
      "download": {
        "title": "1.写真同期ツールのダウンロード",
        "step1": "サイドメニューの「その他」から「設定」を開き、「写真同期ツール」をクリックしてください。",
        "step2": "「写真同期ツールをダウンロード」ボタンを押し、インストーラーをダウンロードしてください。",
        "step2_note": "写真同期ツールのダウンロードはスマートフォンではできません。お使いのPCからご利用ください。",
        "step3": "「MetamoryClient_x64-setup.exe」がダウンロードされていることを確認してください。"
      },
      "install": {
        "title": "2.写真同期ツールのインストール",
        "step1": "先ほどダウンロードした「MetamoryClient_x64-setup.exe」をダブルクリックして起動してください。",
        "step1_note": "「WindowsによってPCが保護されました」と表示された場合は、「詳細情報」を押してから右下の「実行」をクリックしてください。",
        "step3": "「この不明な発行元からのアプリがデバイスに変更を加えることを許可しますか？」と表示された場合は、「はい」を選択してください。",
        "step4": "「セットアップウィザードが完了しました」と表示されたら、インストーラーは閉じて構いません。",
        "step5": "初回起動時に、このような画面が表示されます。",
        "step5b": "「Metamoryでサインイン」ボタンをクリックすると、自動でブラウザが起動し、このような画面が表示されます。",
        "step5_email": "「Email address」にMetamoryアカウントを作成する際に入力したメールアドレスを、「Password」にMetamoryアカウントのパスワードを入力してください。",
        "step5_success": "「Authentication successful! You can close this window.」と表示されたら認証完了です。（ページは閉じて構いません。）"
      },
      "confirm": {
        "title": "3.写真同期ツールの起動確認・終了",
        "step1": "インストールまでの手順が完了すると、Metamory写真同期ツールが自動起動され、以降もPCを起動する度に自動で起動し、VRChatで撮影した写真を自動で同期します。",
        "step1_note": "写真同期ツールの起動とログイン認証が正常に完了している場合、Metamoryの「設定」→「写真同期ツール」で、同期中のデバイスが確認できます。"
      },
      "faq": {
        "title": "よくある質問と回答",
        "sync_issue": {
          "short_title": "自動同期されない",
          "title": "写真同期ツールによる自動同期が行われない",
          "step1": "通知領域（タスクバー右側）から、写真同期ツールが起動しているかどうかをご確認ください。",
          "step2": "通知領域の写真同期ツールアイコンをクリックして「ダッシュボード」を開き、左下を確認することで正しいアカウントで認証されているか確認できます。認証されていない場合はこのような画面が表示されます。",
          "step3": "通知領域の写真同期ツールアイコンをクリックして「ダッシュボード」を開き、「自動アップロード」スイッチがオンになっているのを確認してください。"
        },
        "world_info": {
          "short_title": "ワールド情報が同期されない",
          "title": "自動アップロードされる写真にワールド情報・ユーザー情報が同期されていない",
          "step1": "写真がアップロードされていても、ワールド・ユーザー情報は同期されていないことがあります。数分待ってからもう一度お試しください。",
          "step2": "VRChatの設定でログファイルを出力しない設定にしている場合、ワールド・ユーザー情報の同期が行われないことがあります。VRChat内の設定から、ログファイルを出力する設定に変更してください。"
        },
        "app_not_start": {
          "short_title": "アプリが起動しない",
          "title": "写真同期ツールが起動しなくなった",
          "step1": "通知領域（タスクバー右側）から、写真同期ツールが起動しているかどうかをご確認ください。",
          "step2": "他のアプリ（ウィルス対策ソフトなど）が干渉している場合や、PCやドライバーなどのアップデートによって起動しなくなることがあります。",
          "step2_note1": "直近にインストールしたアプリを無効化・削除してもう一度お試しください。",
          "step2_note2": "改善しない場合は運営までお問い合わせください。"
        },
        "pause_delete": {
          "short_title": "一時停止・削除",
          "title": "写真同期ツールを一時停止・削除したい",
          "step1": "一時停止したい場合は、通知領域の写真同期ツールアイコンをクリックして「ダッシュボード」を開き、「自動アップロード」スイッチをOFFにしてください。",
          "step2": "終了したい場合は、通知領域の写真同期ツールアイコンを右クリックし、「Quit Metamory」を選択してください。",
          "step3": "写真同期ツールを完全に停止させる場合は、Windowsの「設定」→「アプリ」→「インストールされているアプリ」から「Metamory Client」をアンインストールしてください。"
        },
        "vrchat_account": {
          "short_title": "VRChat別アカウント",
          "title": "VRChatに別アカウントでログインしたら自動同期が行われなくなった",
          "step1": "現時点では、MetamoryはVRChatの複数アカウントでの写真や情報の同期をサポートしていません。撮影した写真を手動でアップロードするか、写真同期ツールをインストールしていた際に使用していたアカウントで自動アップロードをご利用ください。"
        },
        "metamory_account": {
          "short_title": "Metamory別アカウント",
          "title": "Metamoryの別アカウントを作成したが、自動同期が行われない",
          "step1": "Metamoryの写真同期ツールは、認証を行った一つのMetamoryアカウントにのみ紐づく仕様です。",
          "step2": "紐づけるアカウントを変更したい場合は、ダッシュボードの「設定」→「アカウント」→「サインアウト」ボタンでサインアウトしてから再認証してください。"
        }
      }
    }
  },
  "urge_reload": {
    "title": "Metamoryのバージョンが更新されました",
    "description": "Metamoryのバージョンが更新されました。最新の機能を利用するために、ページを更新してください",
    "reload": "ページを更新"
  },
  "plan": {
    "current_plan": "現在ご利用中のプラン",
    "current_use_storage": "使用しているストレージ",
    "storage_source": {
      "title": "ストレージの内訳",
      "subscription": "サブスクリプション",
      "promotions": "プロモーション",
      "valid_until": "有効期限: {{date}}",
      "no_promotions": "利用中のプロモーションはありません",
      "permanent": "無期限"
    },
    "payment_interval_annual_label": "年払い",
    "payment_interval_annual_discount": "{{percent}}%お得",
    "discount_available": "割引あり",
    "payment_interval_monthly": "月払い",
    "storage_feature": "<b>{{storage}}GB</b>のストレージ",
    "price_format_annual": "{{price}}円/年",
    "price_format_monthly": "{{price}}円/月",
    "upgrade_plan": "{{planTitle}}プランにアップグレード",
    "downgrade_plan": "{{planTitle}}プランにダウングレード",
    "features_earlyaccess": "新機能への早期アクセス",
    "features_fast_access": "過去写真への高速アクセス",
    "features_original_image": "オリジナル画像の保存",
    "features_ad_free": "広告非表示",
    "price_with_discount": "¥{{price}}/月（{{percent}}%お得）",
    "upgrade_to": "{{plan}}プランにアップグレードしました",
    "downgrade_to": "{{plan}}プランにダウングレードしました",
    "enjoy_plan": "追加ストレージや機能をお楽しみください！",
    "back_to_plan": "プランに戻る",
    "back_to_home": "ホームに戻る",
    "failled_settle_title": "決済に失敗しました",
    "failled_settle_description": "決済エラーが発生しました。時間を置いてやり直してください。\n繰り返し発生する場合は、Metamoryまでご連絡ください。",
    "processing_subscription_title": "サブスクリプションを処理中...",
    "processing_subscription_description": "少々お待ちください。まもなく反映されます。",
    "subscription_timeout_title": "サブスクリプションを処理中です",
    "subscription_timeout_description": "処理に時間がかかっています。まもなくプランに反映されますので、しばらくお待ちください。",
    "using_current_plan": "このプランを利用中です",
    "annual_to_monthly_downgrade": "このプランに更新すると、以前のプラン（{{current_plan_name}}（1年分））で支払った料金 {{current_plan_price}}円 は返金されません。\nMetamoryでは、<b>{{recommended_plan_name}}（1年分）</b>へのアップグレードを推奨しています。（{{recommended_plan_price}}円でアップグレード可能です）\n本当にプランを変更しますか？",
    "limit_photos_num": "{{num}}枚まで無料で保存",
    "free_price": "無料",
    "most_popular": "人気",
    "savings_annual": "年間{{num}}円お得",
    "management": {
      "header_title": "プランの管理",
      "current_plan": "現在ご利用中のプラン",
      "next_billing_date": "次回の請求予定日",
      "current_plan_expiration_date": "現在のプランの有効期限",
      "next_billing_amount": "次回の請求金額",
      "payment_method": "お支払い方法",
      "change_payment_method": "変更",
      "cancel_plan": "プランを解約",
      "cancel_plan_already_canceled": "解約済み",
      "resume_plan": "プランを再開",
      "resume_plan_success": "プランを再開しました",
      "update_creditcard_success": "クレジットカード情報を更新しました",
      "update_creditcard_error": "クレジットカード情報の更新に失敗しました",
      "par_one_year": "/1年",
      "par_one_month": "/1月"
    },
    "cancel": {
      "title": "プランを解約しますか？",
      "message": "利用中のプラン ({{plan_name}}) を解約しようとしています。\nプランを解約すると、ストレージ不足分の<b>{{photo_count}}枚の写真</b>が削除されます。ストレージ容量が不足している間は、写真の自動アップロードも一時停止されます。",
      "date": "解約予定日",
      "confirm_button": "プランを解約",
      "cancel_button": "解約しない",
      "confirm_message": "プランを解約する場合は、確認のためMetamory IDを入力してください",
      "confirm_text": "プランを解約",
      "confirm_ok": "解約する",
      "success": "プランを解約しました"
    },
    "downgrade": {
      "title": "プランを変更しますか？",
      "message": "利用中のプラン ({{plan_name}}) を変更しようとしています。\nプランを変更すると、ストレージ不足分の<b>{{photo_count}}の写真</b>が削除されます。ストレージ容量が不足している間は、写真の自動アップロードも一時停止されます。",
      "confirm_button": "プランを変更",
      "date": "プラン変更予定日",
      "cancel_button": "プランを変更しない",
      "confirm_text": "プランを変更",
      "success": "プランを変更しました"
    },
    "confirm": {
      "title": "{{plan}} プランに変更しますか？",
      "charge_amount": "本日 <b>{{amount}}</b> が請求されます",
      "no_immediate_charge": "本日の請求はありません",
      "next_billing_date": "次回請求日",
      "confirm_and_charge": "同意して支払う",
      "confirm": "変更する",
      "cancel": "キャンセル",
      "processing": "処理中...",
      "preview_error": "金額の取得に失敗しました。時間をおいて再度お試しください。"
    }
  },
  "common": {
    "loading": "読み込み中……"
  },
  "maintenance": {
    "title": "メンテナンス中",
    "message": "ただいまメンテナンスを実施しております。",
    "sub_message": "しばらくお待ちください。"
  },
  "timeline": {
    "empty": {
      "main": {
        "title": "まだ写真がありません",
        "message": "ユーザーや公開アルバムから写真が共有されると、ここに表示されます。",
        "action": "ユーザーを探す"
      },
      "me": {
        "title": "まだ写真を投稿していません",
        "message": "写真をアップロードして、あなたの思い出をシェアしましょう。",
        "action": "写真をアップロード"
      },
      "noFriends": {
        "title": "まだ誰もフォローしていません",
        "message": "ユーザーをフォローして、彼らの写真をタイムラインで見ましょう。",
        "action": "ユーザーを探す"
      },
      "noPhotos": {
        "title": "写真がありません",
        "message": "このタイムラインにはまだ写真がありません。"
      }
    }
  },
  "report": {
    "album_unavailable": "アルバムの報告は現在利用できません",
    "report": "報告する",
    "report_photo": "写真を報告する",
    "report_album": "アルバムを報告する",
    "report_user": "ユーザーを報告する",
    "dialog_title_photo": "この写真を報告しますか？",
    "dialog_title_album": "このアルバムを報告しますか？",
    "dialog_title_user": "このユーザーを報告しますか？",
    "reason_label": "報告の理由",
    "reason_inappropriate_icon": "不適切なアイコン画像",
    "reason_inappropriate_name": "不適切なユーザー名・ID",
    "reason_inappropriate_bio": "不適切な自己紹介文",
    "reason_sexual_content": "性的なコンテンツ",
    "reason_violence": "暴力的なコンテンツ",
    "reason_harassment": "嫌がらせ",
    "reason_other": "その他",
    "comment_placeholder": "詳細をご記入ください（任意）",
    "submit": "報告する",
    "cancel": "キャンセル",
    "success": "報告を送信しました",
    "error": "報告の送信に失敗しました",
    "already_reported": "すでに報告済みです",
    "guidelines_link": "ガイドライン",
    "guidelines_message": "報告する前に<0>ガイドライン</0>をご確認ください。"
  },
  "sensitive": {
    "overlay_message": "センシティブなコンテンツ",
    "show_button": "表示する",
    "birth_date": "生年月日",
    "birth_date_input_title": "生年月日の設定",
    "birth_date_required": "生年月日は必須です",
    "birth_date_invalid": "正しい生年月日を入力してください",
    "birth_date_under_18": "18歳未満の方は表示できません",
    "birth_date_setting": "生年月日設定",
    "birth_date_setting_description": "センシティブな内容の表示に使用されます",
    "birth_date_change_restriction": "生年月日は3ヶ月に1回まで変更できます",
    "birth_date_dialog_description": "このコンテンツを表示するには、あなたの生年月日を入力してください。\n（設定ページであとから変更することもできます）",
    "global_filter_title": "センシティブコンテンツフィルター",
    "global_filter_description": "センシティブなコンテンツの表示を制御します",
    "global_filter_enabled": "有効",
    "global_filter_disabled": "無効",
    "global_filter_restriction_title": "設定変更不可",
    "global_filter_restriction_message": "18歳未満の方、または生年月日が未設定の方は、センシティブコンテンツフィルターを無効にできません。",
    "birth_date_next_change_date": "次回変更可能日: {{date}}",
    "birth_date_save": "生年月日を保存",
    "birth_date_updated": "生年月日を更新しました",
    "sensitive_album_confirm_message": "センシティブな内容が含まれるアルバムです。\n内容を表示しますか？",
    "under_18_cannot_view_album": "18歳未満のユーザーはこのコンテンツを閲覧することができません",
    "login_required_message": "センシティブな内容が含まれるアルバムです。\n閲覧するにはログインが必要です"
  },
  "muted": {
    "overlay_message": "ミュートしたユーザー",
    "show_button": "表示する",
    "album_confirm_message": "ミュートしているユーザーがオーナーのアルバムです。\n内容を表示しますか？"
  },
  "desktop_callback": {
    "redirecting": "Metamoryクライアントにリダイレクトしています...",
    "redirecting_description": "ブラウザのプロンプトが表示されたら「開く」をクリックしてください。",
    "having_trouble": "アプリが開かない場合はこちら",
    "manual_description": "アプリが自動的に開かなかった場合は、以下のコードをコピーしてMetamoryクライアントに貼り付けてください。",
    "copy": "コピー",
    "copied": "コピー済み",
    "expiry_warning": "このコードは約5分で期限切れになります。",
    "missing_params": "認証パラメータが見つかりません。もう一度クライアントからサインインしてください。",
    "expiry_warning_minutes_one": "このコードは約{{count}}分で期限切れになります。",
    "expiry_warning_minutes_other": "このコードは約{{count}}分で期限切れになります。",
    "open_client": "Metamoryクライアントを開く",
    "never_share": "このコードは、このパソコンの Metamory デスクトップアプリにだけ貼り付けてください。Metamory の運営を名乗る人を含め、誰にも教えないでください。"
  },
  "desktop_handoff": {
    "title": "デスクトップアプリにサインイン",
    "question": "{{name}} として Metamory デスクトップアプリにサインインしますか？",
    "description": "承認すると、このパソコンの Metamory デスクトップアプリがこのアカウントでサインインします。デスクトップアプリからサインインを始めていない場合は、キャンセルしてください。",
    "approve": "承認する",
    "cancelled_title": "サインインをキャンセルしました",
    "cancelled_description": "デスクトップアプリには何も送信していません。このタブは閉じてかまいません。",
    "invalid_params": "サインイン用のリンクが正しくありません。もう一度 Metamory デスクトップアプリからサインインしてください。",
    "not_enabled": "この環境では、デスクトップアプリへのサインインが有効になっていません。",
    "failed": "デスクトップアプリへのサインインを準備できませんでした。もう一度お試しください",
    "error_title": "デスクトップアプリにサインインできません",
    "framed": "このページは他のページの中では開けません。Metamory デスクトップアプリからもう一度サインインしてください。",
    "refused": "現在のサインイン状態では、デスクトップアプリへのサインインを利用できません。",
    "account_error": "アカウント情報を読み込めませんでした。",
    "not_you": "別のアカウントを使う場合はサインアウト"
  },
  "history": {
    "disappeared": "表示できなくなった履歴があります",
    "user": {
      "empty": "交流履歴がありません",
      "empty_hint": "写真同期ツールをダウンロードして、思い出を振り返りましょう",
      "more": "もっと見る",
      "expand": "{{name}}の交流履歴を表示",
      "collapse": "{{name}}の交流履歴を閉じる",
      "load_failed": "交流履歴を取得できませんでした。"
    },
    "title": "交流履歴",
    "worlds": "ワールド",
    "users": "ユーザー",
    "search": {
      "worlds_placeholder": "ワールド名で履歴を検索",
      "users_placeholder": "ユーザー名で履歴を検索",
      "worlds_filter": "ワールド：",
      "users_filter": "ユーザー：",
      "cancel": "検索を取り消す",
      "clear": "検索条件を解除",
      "change_named": "検索条件「{{name}}」を変更",
      "loading": "候補を検索中",
      "failed": "候補を取得できませんでした。",
      "empty": "該当する履歴がありません。",
      "refine": "候補が50件を超えています。検索語を絞ってください。"
    },
    "coming_soon": "準備中",
    "order": "並び順",
    "newest": "新しい順",
    "oldest": "古い順",
    "show_available": "閲覧できる履歴を表示",
    "invalid_link": "日時にはタイムゾーン付きの正しい日時を指定してください。",
    "outside_range": "指定の日時は閲覧できる期間の外です。",
    "visit_missing": "この訪問は見つからないか、現在閲覧できません。",
    "empty": "まだワールド訪問履歴がありません。同期ツールで訪問履歴を同期してください。",
    "sync_tool": "同期ツールについて",
    "retry": "再試行",
    "index_changed": "履歴が変更されました。更新して再試行してください。",
    "range_error": "この範囲の履歴を取得できませんでした。",
    "loading": "訪問履歴を読み込み中",
    "scroll_date": "訪問日をスクロール",
    "detail": {
      "expand": "訪問の詳細を開く",
      "collapse": "訪問の詳細を閉じる",
      "open_world_url": "ワールドを別タブで開く",
      "participant_count": "{{count}}人のユーザー",
      "photo_count": "写真{{count}}枚",
      "duration": "{{hours}}時間{{minutes}}分",
      "staying": "滞在中",
      "join": "入室",
      "leave": "退出",
      "other_participants": "他{{count}}名",
      "all_participants": "参加者",
      "not_registered": "Metamory未登録",
      "encounter_count_label": "出会った回数",
      "last_encounter_label": "最後に出会った日",
      "encounter_count": "{{count}}回",
      "open_profile": "プロフィールを表示",
      "profile_unavailable": "Metamoryに登録していないユーザーの\nプロフィールは表示できません",
      "encounter_load_failed": "交流情報を取得できませんでした。",
      "detail_load_failed": "訪問の詳細を取得できませんでした。",
      "visit_not_found": "この訪問は見つかりませんでした。",
      "retry": "再試行",
      "open_photo": "{{date}}の写真を開く",
      "timeline_truncated": "これ以降の履歴は省略されています。",
      "create_my_album": "マイアルバムを作成",
      "album_name": "{{date}} {{world}}にて",
      "you": "あなた",
      "name_separator": "、",
      "join_sentence": " が入室しました",
      "leave_sentence": " が退出しました",
      "show_participants": "参加者{{count}}人を表示",
      "duration_hours": "{{hours}}時間"
    },
    "album_invitation_failed": "アルバムは作成済みです。一部の招待に失敗しました。相手を調整して完了を押すと、未完了の招待だけ再試行します。戻ると作成済みアルバムを開きます。",
    "album_no_invitations": "この公開範囲では参加者を招待しません。",
    "album_invitation_limit": "招待待ちは100人までです。招待する相手を100人以下に減らすか、自動承認を有効にしてください。"
  },
  "world": {
    "search_no_result": "ワールドが見つかりませんでした",
    "search_no_result_description": "ワールド名または識別子を変えて検索してください。",
    "search_limit": "ワールドが見つからないときは",
    "search_limit_description": "候補は最大50件です。検索語を追加して絞り込んでください。"
  },
  "passkey": {
    "title": "パスキー",
    "description": "パスキーを使うと、パスワードの代わりに指紋・顔認証・画面ロックでログインできます。パスキーは端末やパスワードマネージャーに保存されます。",
    "add": "パスキーを追加",
    "added": "パスキーを追加しました",
    "empty": "パスキーはまだありません",
    "empty_description": "パスキーを追加すると、次回からパスワードなしでログインできます",
    "unnamed": "名前のないパスキー",
    "created_at": "追加日: {{date}}",
    "attachment_platform": "端末に内蔵",
    "attachment_cross_platform": "セキュリティキー・他の端末",
    "delete_named": "{{name}}を削除",
    "delete_confirm": "「{{name}}」を削除しますか？\nこのパスキーではログインできなくなります。端末やパスワードマネージャーに残ったパスキーは、それぞれの設定から削除してください。",
    "deleted": "パスキーを削除しました",
    "delete_failed": "パスキーを削除できませんでした",
    "list_error": "パスキーの一覧を読み込めませんでした",
    "canceled": "パスキーの操作をキャンセルしました",
    "already_registered": "この端末にはすでにこのアカウントのパスキーがあります",
    "not_supported": "このブラウザ・端末ではパスキーを利用できません",
    "failed": "パスキーを利用できませんでした。時間をおいてもう一度お試しください",
    "limit_reached": "登録できるパスキーの数が上限に達しました。使っていないパスキーを削除してから追加してください",
    "nudge": "次回から指紋や顔認証でログインできるよう、パスキーを追加しませんか？",
    "nudge_action": "追加する"
  }
}
